import { FormikProps } from "formik";
import { getTexts } from "../texts";
import { AccordionBody, AccordionHeader, AccordionItem } from "../../Accordion";
import { Heading4, Heading5 } from "../Headings";
import { FormRadio, FormRadioList } from "../../form/FormRadio";
import ValidationError from "../../form/ValidationError";
import { TilsynserklaeringFormValues } from "../../../interfaces/tilsynserklaering";
import { tilsynSection3CompleteHelper } from "../../../util/tilsynserklaering/isComplete";
import IsRequired from "../../form/IsRequired";

const TilsynerklaeringSection3 = ({
  texts,
  props,
}: {
  texts: ReturnType<typeof getTexts>;
  props: FormikProps<TilsynserklaeringFormValues>;
}) => {
  const { values, errors, touched } = props;
  const { section3IsStarted, section3IsComplete } =
    tilsynSection3CompleteHelper(values, errors, touched);

  return (
    <AccordionItem value="3">
      <AccordionHeader
        sectionStarted={section3IsStarted}
        sectionComplete={section3IsComplete}
      >
        {texts.section3.title}
      </AccordionHeader>
      <AccordionBody>
        <div className="vstack gap-5">
          <div>
            <Heading4>{texts.section3.section3_1.title}</Heading4>
            <Heading5>
              {texts.section3.section3_1.question.label}
              <IsRequired />
            </Heading5>
            <FormRadioList>
              {texts.section3.section3_1.question.options.map((option) => (
                <FormRadio
                  name={texts.section3.section3_1.question.id}
                  value={option.value}
                  key={option.value}
                  invalid={
                    errors?.[texts.section3.section3_1.question.id] &&
                    touched?.harDuHaftForbrugersager
                  }
                >
                  {option.label}
                </FormRadio>
              ))}
              <ValidationError
                error={errors.harDuHaftForbrugersager}
                show={touched.harDuHaftForbrugersager}
              />
            </FormRadioList>
            {props.values.harDuHaftForbrugersager === "ja" && (
              <>
                <Heading4 className="mt-6">
                  {texts.section3.section3_1a.title}
                </Heading4>
                <Heading5>
                  {texts.section3.section3_1a.question.label}
                  <IsRequired />
                </Heading5>
                <FormRadioList>
                  {texts.section3.section3_1a.question.options.map((option) => (
                    <FormRadio
                      name={texts.section3.section3_1a.question.id}
                      value={option.value}
                      key={option.value}
                      invalid={
                        !!errors?.harDuHaftForbrugersagerUddyb &&
                        touched?.harDuHaftForbrugersagerUddyb
                      }
                    >
                      {option.label}
                    </FormRadio>
                  ))}
                  <ValidationError
                    error={errors.harDuHaftForbrugersagerUddyb}
                    show={touched.harDuHaftForbrugersagerUddyb}
                  />
                </FormRadioList>
              </>
            )}
            <Heading4 className="mt-6">
              {texts.section3.section3_2.title}
            </Heading4>
            <Heading5>
              {texts.section3.section3_2.question.label} <IsRequired />
            </Heading5>
            <FormRadioList>
              {texts.section3.section3_2.question.options.map((option) => (
                <FormRadio
                  name={texts.section3.section3_2.question.id}
                  value={option.value}
                  key={option.value}
                  invalid={
                    errors?.[texts.section3.section3_2.question.id] &&
                    touched?.harDuHaftStraffesager
                  }
                >
                  {option.label}
                </FormRadio>
              ))}
              <ValidationError
                error={errors.harDuHaftStraffesager}
                show={touched.harDuHaftStraffesager}
              />
            </FormRadioList>
          </div>
        </div>
      </AccordionBody>
    </AccordionItem>
  );
};

export default TilsynerklaeringSection3;
